import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    selections: [],
    nextStep: 0,
    claimEventID: 0,

  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/Osm/Claim/store/index.js